'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { ICON_STROKE_MAP } from './config.mjs';

const HistoryIcon = ({ size = 24, ...props }, ref) => /* @__PURE__ */ jsx(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width: size,
    height: size,
    strokeWidth: ICON_STROKE_MAP[size],
    ref,
    "aria-hidden": true,
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M15.5211 15.3803L12.1409 12V7.493M2.84509 4.46202V8.83385V8.96906H7.35213M3.12678 12C3.12678 16.9803 7.16059 21.0141 12.1409 21.0141C17.1211 21.0141 21.155 16.9803 21.155 12C21.155 7.01976 17.1211 2.98596 12.1409 2.98596C8.35495 2.98596 5.12115 5.31836 3.7803 8.61976",
        stroke: "currentColor"
      }
    )
  }
);
const VpHistoryIcon = forwardRef(HistoryIcon);

export { VpHistoryIcon as default };
